import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vip-fill 334",
  "use": "icon-vip-fill 334-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-vip-fill 334\"><path d=\"M552.96 200.128a64 64 0 0 1 8.213333 8.213333L682.666667 354.133333l134.016-98.965333a64 64 0 0 1 100.117333 66.986667L789.333333 832H234.666667L107.2 322.176a64 64 0 0 1 100.117333-67.008L341.333333 354.133333l121.493334-145.792a64 64 0 0 1 90.154666-8.213333zM661.333333 649.962667H362.666667v68.266666h298.666666v-68.266666z\" p-id=\"22655\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol